import React,{useState} from 'react'
import Sets from "../../maxillofacial/desktop/Sets"
import {dataGenerator} from "./data.js";
import i18n from "i18next";


const MediumPlatingSystemSets = (props) => {
	const [data, setData] = useState(dataGenerator(i18n.language))
	i18n.on('languageChanged', function(lng) {
		setData(dataGenerator(lng))
	})
	return (
		<Sets
			title={"mandibularReconstruction.products.4.name"}
			navigate={"mandibular_reconstruction"}
			subtitle={"mandibularReconstruction.products.4.description"}
			sectionTitles={["mandibularReconstruction.sets.titles.1"]}
			titleExtended={["mandibularReconstruction.sets.titles_extended.1"]}
			sectionData={[data.dataSection_1]}
		/>
	)
}

export default (MediumPlatingSystemSets)